import graphql__4749e4355de98639baae from "./__generated__/AnswerPreviewPresentationTitle_answer.graphql.js";import { graphql, useFragment } from "react-relay";

const AnswerPreviewPresentationTitle = props => {
  const answer = useFragment(AnswerPreviewPresentationTitle_answer, props.answer);
  const { label } = answer.formField;

  return <p className="text-subtitle-page">{label}</p>;
};

const AnswerPreviewPresentationTitle_answer = graphql__4749e4355de98639baae;

export default AnswerPreviewPresentationTitle;
